import { render, staticRenderFns } from "./Ovis.html?vue&type=template&id=6a61ccec&scoped=true&external"
import script from "./Ovis.vue?vue&type=script&lang=js"
export * from "./Ovis.vue?vue&type=script&lang=js"
import style0 from "./Ovis.scss?vue&type=style&index=0&id=6a61ccec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a61ccec",
  null
  
)

export default component.exports